import { FC, lazy, ReactNode, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import routeConfig from 'app/config/routes';
import Skeleton from 'react-loading-skeleton';

const CancellationFlow = lazy(
  () =>
    import(
      'app/modules/settings/modules/cancellation/components/CancellationFlow'
    ),
);

const EmbedLayout: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="tw-fixed tw-inset-0 tw-z-[10000] tw-bg-white">
    <style>{`
      #intercom-container,
      .intercom-lightweight-app,
      .intercom-launcher,
      iframe[name="intercom-launcher-frame"],
      iframe[name="intercom-notifications-frame"] {
        display: none !important;
      }
    `}</style>
    {children}
  </div>
);

export const embedRouter: RouteObject = {
  path: routeConfig.embed.path,
  children: [
    {
      path: routeConfig.embed.routes.cancelSubscription.path,
      element: (
        <EmbedLayout>
          <Suspense fallback={<Skeleton width="100%" height="100%" />}>
            <CancellationFlow />
          </Suspense>
        </EmbedLayout>
      ),
    },
  ],
};
